import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const Html = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      key={blok._uid}
      className="html component"
      dangerouslySetInnerHTML={{ __html: blok.HTML }}
    />
  )
}

export default Html
